import HomePage from './containers/HomePage';
import reducer from './reducer';
import { STATE_NAME } from './constants';

export default function initPage(store) {
  store.injectAsyncReducer(STATE_NAME, reducer);

  return HomePage;
}
